<mat-sidenav-container class="example-container">

    <mat-sidenav #sidenav class="sidenav" mode="side">
        <app-sidenav [sidenav]="sidenav"></app-sidenav>
    </mat-sidenav>

    <mat-sidenav-content>

        <div class="navigation">
            <app-toolbar #toolbar [sidenav]="sidenav"></app-toolbar>
        </div>

        <div class="content" (click)="handleSidenav()">
            <router-outlet></router-outlet>
        </div>
        
    </mat-sidenav-content>
</mat-sidenav-container>
